module.exports = __webpack_public_path__ + "static/media/logo.12d04617.png";